



import {Component, Vue} from 'vue-property-decorator';
import {LTileLayer} from 'vue2-leaflet';

@Component({components: {LTileLayer}})
export default class OpenStreetMapLayer extends Vue {
    public readonly url = 'https://{s}.tile.osm.org/{z}/{x}/{y}.png';
    public readonly  attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
}
